<template>
    <div class="app-container">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'wrapper'
    }
</script>
